import { useState } from 'react';
import AuthImage from '../AuthImage';

export const DOC_LABELS = {
  cni_passeport: "Carte d'identité / Passeport",
  cv: 'CV',
  psc: 'PSC',
  certificat_medical: 'Certificat médical',
  photo_identite: "Photo d'identité",
  attestation_natation: 'Attestation natation 100m',
  attestation_recensement: 'Attestation de recensement',
  permis_cotier: 'Permis côtier',
  permis_fluvial: 'Permis fluvial',
  crr: 'CRR',
};

export const formatDateFr = (d) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : (d || '—');
};

export const formatTaille = (o) => (typeof o === 'number' ? `${(o / 1024 / 1024).toFixed(1)} Mo` : '—');

export const PhotoAncien = ({ userId, prenom, nom, className = 'h-16 w-16 text-lg' }) => {
  const [erreur, setErreur] = useState(false);
  const initiales = `${(prenom || '')[0] || ''}${(nom || '')[0] || ''}`.toUpperCase();
  if (erreur) {
    return (
      <div className={`${className} rounded-xl bg-slate-100 text-slate-500 font-semibold flex items-center justify-center shrink-0`} data-testid={`ancien-initiales-${userId}`}>
        {initiales}
      </div>
    );
  }
  return (
    <AuthImage
      src={`/api/anciens-stagiaires/${userId}/photo`}
      alt={`${prenom} ${nom}`}
      className={`${className} rounded-xl object-cover bg-slate-100 shrink-0`}
      onError={() => setErreur(true)}
      data-testid={`ancien-photo-${userId}`}
    />
  );
};

export const ArchiveBadge = ({ statut, allege }) => {
  if (allege) return <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-slate-800 text-white">Allégé</span>;
  const map = {
    pret: ['Archive figée', 'bg-emerald-100 text-emerald-700'],
    en_cours: ['Archive en cours…', 'bg-blue-100 text-blue-700'],
    erreur: ['Archive en erreur', 'bg-red-100 text-red-700'],
  };
  const [label, cls] = map[statut] || ['Sans archive', 'bg-amber-100 text-amber-700'];
  return <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${cls}`}>{label}</span>;
};
